var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerttriangle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 9.00118V13.0012M12.9998 17.0012H13.0098M11.2898 3.86118L2.81978 18.0012C2.64514 18.3036 2.55274 18.6465 2.55177 18.9957C2.55079 19.3449 2.64127 19.6883 2.8142 19.9917C2.98714 20.2951 3.2365 20.5479 3.53748 20.725C3.83847 20.9021 4.18058 20.9973 4.52978 21.0012H21.4698C21.819 20.9973 22.1611 20.9021 22.4621 20.725C22.7631 20.5479 23.0124 20.2951 23.1854 19.9917C23.3583 19.6883 23.4488 19.3449 23.4478 18.9957C23.4468 18.6465 23.3544 18.3036 23.1798 18.0012L14.7098 3.86118C14.5315 3.56729 14.2805 3.3243 13.981 3.15567C13.6814 2.98703 13.3435 2.89844 12.9998 2.89844C12.656 2.89844 12.3181 2.98703 12.0186 3.15567C11.7191 3.3243 11.468 3.56729 11.2898 3.86118Z",
    stroke: "#FEB91E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerttriangle4);
export default __webpack_public_path__ + "static/media/Alert triangle (4).90ba453b4ce54631909023263c4b7568.svg";
export { ForwardRef as ReactComponent };